<script lang="ts" setup>
const props = defineProps({
  to: {
    type: [String, Object],
    default: undefined,
  },
  href: {
    type: String,
    default: undefined,
  },
  target: {
    type: String,
    default: undefined,
  },
  rel: {
    type: String,
    default: undefined,
  },
  noRel: {
    type: Boolean,
    default: false,
  },
  replace: {
    type: Boolean,
    default: false,
  },
  external: {
    type: Boolean,
    default: undefined,
  },
  custom: {
    type: Boolean,
    default: undefined,
  },
  prefetch: {
    type: Boolean,
    default: undefined,
  },
  noPrefetch: {
    type: Boolean,
    default: undefined,
  },
  activeClass: {
    type: String,
    default: undefined,
  },
  exactActiveClass: {
    type: String,
    default: undefined,
  },
  ariaCurrentValue: {
    type: String,
    default: undefined,
  },
  prefetchedClass: {
    type: String,
    default: undefined,
  },
})
const { to, href } = toRefs(props)

const goTo = computed(() => {
  if (typeof to.value === 'object') {
    const router = useRouter()
    return useSanitizeUrl(router.resolve(to.value ?? '').href)
  }

  return useSanitizeUrl(to?.value || href?.value || '')
})

const { triggerChat } = useChat()

const startChat = () => {
  triggerChat.value = true
}

const linkProps = computed(() => {
  const linkProps: Record<string, unknown> = {
    ...props,
    // to: props.to || props.href,
    // rel: props.rel,
    // noRel: props.noRel,
    // target: props.target,
    // external: props.external,
  }

  linkProps.to = goTo.value

  if (linkProps.rel) {
    linkProps.rel = linkProps.rel || goTo.value?.includes('http') ? 'noopener noreferrer' : undefined
  }

  linkProps.target = linkProps.target || goTo.value?.includes('http') ? '_blank' : undefined
  linkProps.external = linkProps.external || goTo.value?.includes('http')

  // delete linkProps.href
  linkProps.href = undefined

  if (linkProps.noRel) {
    linkProps.rel = undefined
    // delete linkProps.rel
  }

  // for (const prop in linkProps) {
  //   if (linkProps[prop] === undefined) {
  //     delete linkProps[prop]
  //   }
  // }

  return linkProps
})
</script>

<template>
  <button
    v-if="goTo.startsWith('aiden-advisor-id:')"
    type="button"
    :data-advisor-id="goTo.replace('aiden-advisor-id:', '')"
    :class="[$props.class]"
  >
    <slot />
    <LazyThirdpartyAiden />
  </button>
  <button
    v-else-if="goTo.endsWith('#chat')"
    type="button"
    @click="startChat"
  >
    <slot />
  </button>
  <NuxtLink
    v-else
    v-bind="linkProps"
  >
    <slot>{{ goTo }}</slot>
  </NuxtLink>
</template>
